function updateRowCounters(table) {
    let counter = 1;
    [...table.tBodies[0]?.rows ?? []].forEach(row => {
        const cell = row.querySelector('[data-row-counter]');
        if (cell && !row.hidden) cell.textContent = counter++;
    });
}

function applyTableFilters(table, filters) {
    const activeFilters = filters
        .filter(filter => filter.value !== '')
        .map(filter => ({ key: filter.dataset.filterKey, value: filter.value }));

    let visibleRows = 0;
    [...table.tBodies[0]?.rows ?? []].forEach(row => {
        const visible = activeFilters.every(filter => {
            const values = (row.dataset[filter.key] || '').split('|');
            return values.includes(filter.value);
        });
        row.hidden = !visible;
        if (visible) visibleRows++;
    });

    updateRowCounters(table);
    const emptyMessage = document.querySelector(`[data-table-empty-for="${table.id}"]`);
    if (emptyMessage) emptyMessage.hidden = visibleRows !== 0;
}

export function initTableFilters(root = document) {
    const filtersByTable = new Map();

    root.querySelectorAll('[data-table-filter][data-table-target]').forEach(filter => {
        const table = document.querySelector(filter.dataset.tableTarget);
        if (!table) return;
        if (!filtersByTable.has(table)) filtersByTable.set(table, []);
        filtersByTable.get(table).push(filter);
    });

    filtersByTable.forEach((filters, table) => {
        filters.forEach(filter => {
            filter.addEventListener('change', () => applyTableFilters(table, filters));
        });
        applyTableFilters(table, filters);
    });
}
